import { useQuery } from "@tanstack/react-query";
import { listScheduleIssues } from "./issues-api";

// The tolerance is part of the key so changing the "accept small overlaps"
// control refetches (and caches) per-tolerance. Mutations invalidate on the
// scheduleId prefix, so they still clear every tolerance variant.
export const ISSUES_KEY = (scheduleId: string) =>
  ["schedule-issues", scheduleId] as const;

export function useScheduleIssues(
  scheduleId: string,
  options: { enabled?: boolean; toleranceMinutes?: number } = {},
) {
  const enabledGate = options.enabled ?? true;
  const toleranceMinutes = options.toleranceMinutes ?? 0;
  return useQuery({
    queryKey: [...ISSUES_KEY(scheduleId), toleranceMinutes] as const,
    queryFn: () => listScheduleIssues(scheduleId, toleranceMinutes),
    enabled: enabledGate && !!scheduleId,
  });
}
